// @flow
import { GET_INSTRUCTOR_INFO } from './schedule.consts.js';

import type { Locations, Instructors, Instructor } from './schedule.types.js';

export const locations = (state: Locations = {}) => state;
export const locationsList = (state: List = {}) => state;

export const instructors = (state: Instructors = {}) => state;

export const instructor = (state: Instructor = {}, action: Action) => {
  switch (action.type) {
    case GET_INSTRUCTOR_INFO:
      if (!action.payload.instructor) return {};
      return {
        ...action.payload.instructor,
        schedule: action.payload.schedule,
        locationID: action.payload.locationID
      };
    default:
      return state;
  }
};

export const user = (state: $ElementType<ReduxState, 'user'> = {}) => state;
export const URL = (state: $ElementType<ReduxState, 'URL'> = {}) => state;

export const accessgroups = (state: $ElementType<ReduxState, 'accessgroups'> = {}) => state;
